<template>
  <sharing-metadata
    :metadata-props="facebookMetadata"
    @update="$emit('update', $event)"
    @invalid="$emit('invalid')"
  >
    <template v-slot:header>Facebook metadata</template>
    <template v-slot:content="contentData">
      <el-form-item label="Title" prop="title">
        <el-input v-model="contentData.metadata.title" clearable />
      </el-form-item>
      <el-form-item label="Description" prop="description">
        <el-input
          v-model="contentData.metadata.description"
          type="textarea"
          class="youtube-description__input"
          :rows="4"
        />
      </el-form-item>
    </template>
  </sharing-metadata>
</template>

<script>
import SharingMetadata from "@/components/socials/share/metadata/SharingMetadata.vue";

// @group Socials
// Facebook sharing additional data (description) input
export default {
  name: "SharingFacebookMetadata",
  components: {
    SharingMetadata
  },
  props: {
    /** Facebook video title */
    title: {
      type: String,
      default: "No title"
    },
    /** Facebook video description */
    description: {
      type: String,
      default: ""
    }
  },
  computed: {
    // @vuese
    // Facebook metadata properties
    facebookMetadata() {
      return [
        {
          id: "title",
          value: this.title,
          rules: [
            {
              required: true,
              message: "Title is required",
              trigger: "change"
            }
          ]
        },
        {
          id: "description",
          value: this.description
        }
      ];
    }
  }
};
</script>
